import React from "react";

interface ProductBadgeProps {
  badgeText: string | null;
  isInCart: boolean;
  isInProductList: boolean;
  isInQuoteList: boolean;
}

const ProductBadge: React.FC<ProductBadgeProps> = ({
  badgeText,
  isInCart,
  isInProductList,
  isInQuoteList
}) => {
  if (badgeText == null) return null;

  let className = "product-badge";

  if (isInCart) className += " in-cart";
  else if (isInProductList) className += " in-productList";
  else if (isInQuoteList) className += " in-quoteList";

  return <div className={className}>{badgeText}</div>;
};

export default ProductBadge;
